<template>
  <TimeEntriesBaseSelectFilter
    class="activity-level-filter"
    data-testid="time-entries-activity-level-filter"
    label="Activity Level"
    placeholder="All levels"
    :options="activityLevelOptions"
    query-property="activity_level"
    :multiple="false"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesActivityLevelFilter',
  computed: {
    ...mapGetters(['activityLevelOptions']),
  },
};
</script>
